import { getService } from 'react-in-angularjs';
/**
 * @returns current path and prams if exist (e.g. /path?param1=value1&param2=value2)
 */
export const getCurrentUrl = () => {
  const $location = getService('$location');

  return $location.url();
};
